// extracted by mini-css-extract-plugin
module.exports = {"root":"Recovery-module__root___23y0g","error":"Recovery-module__error___3vr_U Fonts-module__mt___2w9Sq"};